const SAVE_TAX = {
  navigationHeaderDataAid: "1",
  landingHeader: {
    dataAid: "saveTax",
    title: {
      text: "Save tax ",
    },
    subTitle: {
      text: "Balance out risk & return on investments with ELSS",
    },
  },
  saveTaxBenefits: {
    title: {
      text: "Benefits of investing in ELSS ",
      dataAid: "title",
    },
    content: {
      titleDataAid: "title",
      iconDataAid: "left",
    },
  },
  cta: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

export default SAVE_TAX;
